import { Box } from "@mui/material";
import React from "react";
import { DataGridPro } from "@mui/x-data-grid-pro";
import DataGridCustomToolbar from "components/DataGridCustomToolBar";
import { useOrgGrid } from "./hooks/useOrgGrid";

function OrgGrid({ handleEditOpen }) {
  const {
    organisations,
    totalOrgs,
    columns,
    page,
    setPage,
    pageSize,
    setPageSize,
    search,
    setSearch,
    searchInput,
    setSearchInput,
    sort,
    setSort,
    backgroundAlt,
    primaryLight,
  } = useOrgGrid({ handleEditOpen });

  return (
    <Box
      mt="40px"
      sx={{
        "& .MuiDataGrid-root": {},
        "& .MuiDataGrid-cell": {
          whiteSpace: "normal",
          wordBreak: "break-word",
          overflow: "visible",
        },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: backgroundAlt,
        },
        "& .MuiDataGrid-virtualScroller": {
          backgroundColor: backgroundAlt,
        },
        "& .MuiDataGrid-footerContainer": {
          backgroundColor: primaryLight,
        },
        "& .MuiDataGrid-row": {
          height: "auto", // This ensures the row height adapts to content
        },
      }}
    >
      <DataGridPro
        getRowId={(row) => row._id}
        rows={organisations}
        columns={columns}
        page={page}
        pageSize={pageSize}
        rowCount={totalOrgs}
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        onPageChange={(params) => {
          setPage(params);
        }}
        onPageSizeChange={(newPageSize) => {
          setPage(0);
          setPageSize(newPageSize);
        }}
        paginationMode="server"
        components={{
          Toolbar: DataGridCustomToolbar,
        }}
        componentsProps={{
          toolbar: {
            search,
            setSearch,
            searchInput,
            setSearchInput,
            sort,
            setSort,
          },
        }}
        disableSelectionOnClick
        autoHeight
        rowHeight={50}
      />
    </Box>
  );
}

export default OrgGrid;
